const translation = {
    fr: {
        // Navigation
        home: 'Accueil',
        menu: 'Menu',
        contact: 'Contact',
        viewMenu: 'Voir le Menu',
        
        // Hero Section
        heroBadge: 'Depuis 1989 ',
        heroTitle: "Pizza Américaine",
        heroSubtitle: 'Nos pizzas généreuses et savoureuses, préparées avec amour dans nos pizzerias proches de chez vous',
        orderNow: 'Commander maintenant',
        
        // Story Section
        storyTitle1: 'FAIT AVEC',
        storyTitle2: 'AMOUR & PASSION',
        storyText1: 'Chez Chippy Pizza, nous mettons tout notre savoir-faire au service de votre gourmandise.',
        storyText2: "Depuis des années, nous sélectionnons des ingrédients de qualité pour vous régaler avec nos pizzas généreuses et savoureuses, préparées avec amour dans nos pizzerias proches de chez vous et à partager sans modération !",
        
        // Values Section
        valuesTitle: 'NOTRE SECRET ?',
        valuesSubtitle: "L'engagement qualité qui fait la différence",
        value1Title: '100% Frais Maison',
        value1Desc: 'Notre pâte maison, pétrie chaque jour avec amour et passion',
        value2Title: 'Ingrédients Sélectionnés',
        value2Desc: 'Des produits de qualité premium pour un goût authentique',
        value3Title: 'Livraison Rapide',
        value3Desc: 'Votre pizza chaude directement chez vous quelques minutes',
        
        // Showcase Section
        showcaseTitle: 'NOS RECETTES À LA UNE',
        pizzaMargherita: 'Margherita',
        pizzaMargheritaDesc: 'La classique italienne',
        pizzaPepperoni: 'Pepperoni',
        pizzaPepperoniDesc: 'Pour les amateurs de viande',
        pizzaCheese: '4 Fromages',
        pizzaCheeseDesc: 'Un délice fromager',
        
        // Final CTA
        finalCtaTitle: 'PRÊT À VOUS RÉGALER ?',
        findPizzeria: 'Venez VIITE',
        phoneNumber: '+213 555 123 456',
        
        // Menu Page
        classicPizzas: 'Pizzas Classiques',
        gourmetPizzas: 'Pizzas Gourmandes',
        extras: 'Extras',
        drinks: 'Boissons',
        
        // Contact Page
        contactTitle: 'Contactez-Nous',
        contactSubtitle: 'Une question ? Une suggestion ? Nous sommes à votre écoute !',
        address: 'Adresse',
        addressLine1: "29A Rue d'Italie, 13006 Marseille, France",
        addressLine2: "Marseille",
        phone: 'Téléphone',
        phoneNumber: '+33 695 134 764',
        phoneHours: 'Lun-Dim: 11h-23h',
        email: 'Email',
        emailAddress: 'chippypizza13@gmail.com',
        emailResponse: 'Réponse sous 24h',
        hours: 'Horaires',
        hoursWeekday: 'Lun-Jeu: 17h30-22h30',
        hoursWeekend: 'Ven-Dim: 17h30-23h',
        sendMessage: 'Envoyez-nous un message',
        fullName: 'Nom complet',
        fullNamePlaceholder: 'Votre nom',
        emailPlaceholder: 'votre@email.com',
        phonePlaceholder: '+33 695 123 456',
        message: 'Message',
        messagePlaceholder: 'Votre message...',
        sendButton: 'Envoyer le message',
        successMessage: 'Message envoyé avec succès ! ',
        visitUs: 'Venez nous rendre visite !',
    },
    en: {
        // Navigation
        home: 'Home',
        menu: 'Menu',
        contact: 'Contact',
        viewMenu: 'View Menu',
        
        // Hero Section
        heroBadge: 'Since 1989 ',
        heroTitle: "American Pizza",
        heroSubtitle: 'Our generous and delicious pizzas, prepared with love in our pizzerias near you',
        orderNow: 'Order Now',
        
        // Story Section
        storyTitle1: 'MADE WITH',
        storyTitle2: 'LOVE & PASSION',
        storyText1: 'At Chippy Pizza, we put all our expertise at the service of your taste buds.',
        storyText2: 'For years, we have been selecting quality ingredients to delight you with our generous and tasty pizzas, prepared with love in our pizzerias near you and to be shared without moderation!',
        
        // Values Section
        valuesTitle: 'OUR SECRET?',
        valuesSubtitle: 'The quality commitment that makes the difference',
        value1Title: '100% Fresh Homemade',
        value1Desc: 'Our homemade dough, kneaded every day with love and passion',
        value2Title: 'Selected Ingredients',
        value2Desc: 'Premium quality products for an authentic taste',
        value3Title: 'Fast Delivery',
        value3Desc: 'Your hot pizza delivered directly to you in few minutes',
        
        // Showcase Section
        showcaseTitle: 'OUR FEATURED RECIPES',
        pizzaMargherita: 'Margherita',
        pizzaMargheritaDesc: 'The Italian classic',
        pizzaPepperoni: 'Pepperoni',
        pizzaPepperoniDesc: 'For meat lovers',
        pizzaCheese: '4 Cheeses',
        pizzaCheeseDesc: 'A cheesy delight',
        
        // Final CTA
        finalCtaTitle: 'READY TO ENJOY?',
        findPizzeria: 'COME QUICKLY',
        phoneNumber: '+213 555 123 456',
        
        // Menu Page
        classicPizzas: 'Classic Pizzas',
        gourmetPizzas: 'Want More Flavor?',
        extras: 'Extras',
        drinks: 'Drinks',
        
        
        // Contact Page
        contactTitle: 'Contact Us',
        contactSubtitle: 'Have a question? A suggestion? We\'re here to listen!',
        address: 'Address',
        addressLine1: "29A Rue d'Italie, 13006 Marseille, France",
        addressLine2: "Marseille",
        phone: 'Phone',
        phoneNumber: '+33 695 134 764',
        phoneHours: 'Mon-Sun: 11am-11pm',
        email: 'Email',
        emailAddress: 'chippypizza13@gmail.com',
        emailResponse: 'Reply within 24h',
        hours: 'Hours',
        hoursWeekday: 'Mon-Thu: 5:30pm-10pm',
        hoursWeekend: 'Fri-Sun: 5:30pm-11pm',
        sendMessage: 'Send us a message',
        fullName: 'Full Name',
        fullNamePlaceholder: 'Your name',
        emailPlaceholder: 'your@email.com',
        phonePlaceholder: '+33 695 123 456',
        message: 'Message',
        messagePlaceholder: 'Your message...',
        sendButton: 'Send Message',
        successMessage: 'Message sent successfully!',
        visitUs: 'Come visit us!',
    }
};

export default translation;